import { createSlice } from '@reduxjs/toolkit';

const SELECTED_EVENT_STORAGE_KEY = 'bridged_selected_event';
const SELECTED_WORKFLOW_STORAGE_KEY = 'bridged_selected_workflow_key';

const readStoredJson = key => {
  try {
    const stored = sessionStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

const persistValue = (key, value) => {
  try {
    if (value) {
      sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    } else {
      sessionStorage.removeItem(key);
    }
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
};

const initialState = {
  selectedEvent: readStoredJson(SELECTED_EVENT_STORAGE_KEY),
  selectedWorkflowKey: (() => {
    try {
      return sessionStorage.getItem(SELECTED_WORKFLOW_STORAGE_KEY) || null;
    } catch {
      return null;
    }
  })(),
  isCreateDrawerOpen: false,
};

export const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload || null;
      persistValue(SELECTED_EVENT_STORAGE_KEY, state.selectedEvent);
    },
    setSelectedWorkflowKey: (state, action) => {
      state.selectedWorkflowKey = action.payload || null;
      persistValue(SELECTED_WORKFLOW_STORAGE_KEY, state.selectedWorkflowKey);
    },
    setIsCreateDrawerOpen: (state, action) => {
      state.isCreateDrawerOpen = Boolean(action.payload);
    },
    clearEventContext: state => {
      state.selectedEvent = null;
      state.selectedWorkflowKey = null;
      state.isCreateDrawerOpen = false;
      persistValue(SELECTED_EVENT_STORAGE_KEY, null);
      persistValue(SELECTED_WORKFLOW_STORAGE_KEY, null);
    },
  },
});

export const {
  setSelectedEvent,
  setSelectedWorkflowKey,
  setIsCreateDrawerOpen,
  clearEventContext,
} = eventsSlice.actions;

export const selectSelectedEvent = state => state.events.selectedEvent;
export const selectSelectedWorkflowKey = state => state.events.selectedWorkflowKey;
export const selectIsCreateDrawerOpen = state => state.events.isCreateDrawerOpen;

export default eventsSlice.reducer;
